module.exports = __webpack_public_path__ + "static/img/14000293.805daa7b.png";